import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { SlotModelDay } from 'src/app/beans/slot-model/slot-model.day.bean';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { NetworkManager } from 'src/app/managers/network/network.manager';

@Injectable({
  providedIn: 'root',
})
export class SlotModelRequest {
  constructor(private network: NetworkManager) {}

  listAuto(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_AUTO_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  list(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  detail(token: string, modelId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.MODEL, modelId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  create(token: string, model: SlotModel) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    const data = JSON.stringify(model);

    form.set(RequestField.DATA, data);

    return this.network.http().put(url, form.toString(), { headers });
  }

  update(token: string, model: SlotModel) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    const data = JSON.stringify(model);

    form.set(RequestField.DATA, data);

    return this.network.http().put(url, form.toString(), { headers });
  }

  automate(token: string, slotModelAuto: SlotModelAuto) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_AUTO;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    const data = JSON.stringify(slotModelAuto);

    form.set(RequestField.DATA, data);

    return this.network.http().put(url, form.toString(), { headers });
  }

  manageSlot(token: string, model: number, day: SlotModelDay) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_SLOT;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    const data = JSON.stringify(day);

    form.set(RequestField.DATA, data);
    form.set(RequestField.MODEL, model.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  apply(
    token: string,
    dF: string,
    dT: string,
    s: number,
    m: number,
    h: number,
    d: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SLOTMODEL_APPLY;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.DATE_FROM, dF);
    form.set(RequestField.DATE_TO, dT);
    form.set('service', s.toString());
    form.set('model', m.toString());
    form.set('holiday', h.toString());
    form.set('delete', d.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
